export default __webpack_public_path__ + "static/media/t31.bb1f994d.jpg";